<mat-form-field>
  <input
    placeholder="{{ placeholder }}"
    matInput
    [disabled]="disabled"
    #autocomplete
    type="text"
    class="form-control"
  />
  <mat-icon matPrefix>pin_drop</mat-icon>
</mat-form-field>
